var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn--orange float-right",
        attrs: {
          type: "button",
          disabled: _vm.isAwarded || _vm.isUnderEditing,
          id: "award_tender",
        },
        on: {
          click: function ($event) {
            return _vm.init()
          },
        },
      },
      [_vm._v(_vm._s(_vm.$t("action.awardRegret")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "awardTenderModal",
        staticClass: "reveal",
        staticStyle: { overflow: "visible" },
        attrs: { id: "awardTenderModal" },
      },
      [
        _c("div", [
          _c(
            "button",
            {
              staticClass: "close-reveal-modal float-right close-dialog",
              attrs: { "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.closeAwardTenderModal()
                },
              },
            },
            [_vm._v("×")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-container" }, [
          _c("p", { staticClass: "confirm-header" }, [
            _vm._v(_vm._s(_vm.$t("tender.award.popupTitle"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row align-right nav_btn" },
          [
            _c(
              "DialogSlot",
              {
                ref: "tender-regret-all-modal",
                attrs: {
                  id: "tender-regret-all-modal",
                  modalBtn: _vm.$t("action.regretAll"),
                  modalBtnClass: "btn--darkblue",
                  beforeOpenModal: _vm.beforeOpenModal,
                  showCloseBtn: false,
                },
              },
              [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("span", { staticClass: "confirm-header" }, [
                    _vm._v(_vm._s(_vm.$t("hint.regretAll"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: {
                        type: "button",
                        "data-close": "",
                        "aria-label": "Close reveal",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.rejectAll()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("CreateProject", {
              attrs: {
                isTenderAward: true,
                recommendedBidId: _vm.recommendedBidId,
              },
              on: {
                "close:awardModal": function ($event) {
                  return _vm.closeAwardTenderModal()
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "regretAllAlertModal",
        staticClass: "reveal",
        attrs: { id: "regretAllAlertModal" },
      },
      [
        _c("div", { staticClass: "modal-container" }, [
          _c("p", { staticClass: "confirm-header" }, [
            _vm._v(_vm._s(_vm.$t("tender.award.emailSentMsg"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row align-center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { type: "btn" },
              on: {
                click: function ($event) {
                  return _vm.navHome()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("hint.okay")))]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }